import memoize from 'lodash/memoize';

import { FriendlyRole } from '../../lib/PlannerDTOs';

const DEFAULT_COLOR: string = '#1890ff';

export const ROLES_MAPPING: { role: string; color: string }[] = [
  // colours are chosen from : https://ant.design/docs/spec/colors#Color-Application-In-Enterprise-Product-Design
  { role: 'Editor', color: '#1890ff' }, // blue-6
  { role: 'RolloutModerator', color: '#389e0d' }, // green-7
  { role: 'ExperimentModerator', color: '#c41d7f' }, // magenta-7
  { role: 'Publisher', color: '#d48806' }, // golxd-6
  { role: 'TechSupport', color: '#08979c' }, // cyan-7
  { role: 'Admin', color: '#722ed1' }, // purple-6
];

const experimentalRoles: { [experimentRole: string]: string } = {
  Default: 'XDefaultAccess',
  Administrator: 'XAdministratorAccess',
};

const customTeamsMapping: { [teamName: string]: string } = {
  X: 'Grab-X',
};

/**
 * @param { string } unparsedRole - initial role that comes from server
 *   and is not user friendly
 *
 * @return { FriendlyRole } object with color, team name, readable role and
 *   id which is unparsedRole. Logic is based on "included" and chooses color
 *   basing on ROLES_MAPPING
 */
export default memoize((unparsedRole: string): FriendlyRole => {
  const mappedRoleIncludingGrabX: string =
    experimentalRoles[unparsedRole] || unparsedRole;

  if (mappedRoleIncludingGrabX.endsWith('Access')) {
    const roleWithoutAccess: string = mappedRoleIncludingGrabX.replace(
      'Access',
      '',
    );

    const mappedRole = ROLES_MAPPING.find(({ role }): boolean =>
      roleWithoutAccess.endsWith(role),
    );

    if (mappedRole) {
      const { color, role } = mappedRole;
      const team = roleWithoutAccess.replace(role, '');
      const customTeamName = customTeamsMapping[team];

      return {
        id: unparsedRole,
        team: customTeamName || team,
        role,
        color,
      };
    }
  }

  console.warn('role mapping was not found');

  return {
    id: unparsedRole,
    team: '',
    role: unparsedRole,
    color: DEFAULT_COLOR,
  };
});
